// extracted by mini-css-extract-plugin
export var modal = "_uf-0";
export var table = "_uf-1";